import { useTheme } from '@mui/joy';
import { Box, Stack, Typography } from '@mui/joy';

/* made for the Analysis page */
interface CaptionProps {
	title: string;
	text: string;
}

const Caption = ({ title, text }: CaptionProps) => {
	const theme = useTheme();
	return (
		<Stack
			flexDirection='row'
			gap={1}
			sx={{ marginLeft: { xs: '.5rem', sm: '-1.75rem' } }}
		>
			<Box
				sx={{
					borderRight: `2px solid ${theme.palette.chartElementsBackground.yAxisLabels}`,
					marginY: '2px'
				}}
			></Box>
			<Box sx={{ maxWidth: '760px', lineHeight: '1.2' }}>
				<Typography
					level='caption'
					sx={{
						fontWeight: 'bold',
						display: 'revert'
					}}
				>
					{title}
				</Typography>{' '}
				<Typography
					level='caption'
					sx={{
						display: 'revert'
					}}
				>
					{text}
				</Typography>
			</Box>
		</Stack>
	);
};

export default Caption;
